<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <IzbirnikStranke :selectorPermissions="selectorPermissions" v-on:osvezitevIzbranIdStranka="GetStranka" />
      </div>
    </div>
    <div style="clear: both"/>
    <div>
      <el-dialog
        width="600px"
        append-to-body
        class="uspesno-obvestilo mobile"
        :visible.sync="uspesnoNarociloHBO"
        center>
        <div class="ikona-uspesno">
          <img src="/static/img/MojProfil/Icon-feather-check.png">
        </div>
        <div>
          <p class="navadno-besedilo krepko-center text-block-center">
            Potrjujemo naročilo programskega paketa HBO Premium!
          </p>
        </div>
        <div style="padding-top: 10px">
          <p class="navadno-besedilo text-block-center okno-center">
            Pogodbena določila tega dogovora so vam dostopna na servisnih straneh v zavihku
            <span class="text-block-center">
              "Obrazci / Posebni dogovori".
            </span>
            <span class="text-block-center potrditev">
              <a href="https://hbogo.si/">
                <img src="/static/img/MojProfil/Icon-open-account-login.png">
                Prijava v Max
              </a>
            </span>
          </p>
        </div>
        <el-button class="gumb-brez-obrob krepko crna" @click="uspesnoNarociloHBO = false"
                   style="text-align: center; cursor: pointer;">
          Zapri
        </el-button>
      </el-dialog>
    </div>
    <div style="clear: both"/>
    <div>
      <div class="vsebina-postavitev">
        <div class="odmik-vsebine">
          <div>
            <div style="padding-bottom: 20px">
              <p class="open-sans-30pt">
                T-2 Televizija
              </p>
            </div>
            <div v-if="seznamVsehPrikljuckov.length !== 0">
              <div v-if="seznamVsehPrikljuckov.length > 1">
                <p>
                  Izbrani priključek
                  <IzbirnikPrikljuckaSelect
                    style-class="izbirnik-prikljuckov"
                    @novIzbranPrikljucek="izbranPrikljucek = $event"
                    :izbranPrikljucek="izbranPrikljucek"
                    :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
                  />
                </p>
              </div>
              <el-tabs type="border-card" @tab-click="HandleTabClick" value="t1" v-model="activetab" style="padding-top: 15px">
                <el-tab-pane label="TV Vmesniki" name="t1" ref="t1"
                             :key="izbranPrikljucek + '-t1-'">
                  <div>
                    <TVvmesnik :izbranPrikljucek="izbranPrikljucek"
                               :coax-prikljucek="coaxPrikljucek"
                               :seznamNarocenihTvVmesnikov="seznamNarocenihTvVmesnikov"
                               :seznamVkloplenihTvVmesnikov="seznamVkloplenihTvVmesnikov"
                               :seznamTvVmesnikov="seznamTvVmesnikov"
                               :cenikTvVmesnikov="cenikTvVmesnikov"
                               :stPosodobitveKolicineTvVmesnikov="stPosodobitveKolicineTvVmesnikov"
                               v-on:osvezitevStraniDodajanje="KlicGlobalnihMetod"
                    />
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="nameTabShemeInStoritve" name="t2" ref="t2"
                             :key="izbranPrikljucek + '-t2-'"
                             v-if="prikaziIzbireTvStoritev === true &&
                             (seznamProgramskihShem.length > 0 || seznamDodatnihPaketov.length > 0)">
                  <div>
                    <TVsheme :izbranPrikljucek="izbranPrikljucek"
                             :seznamProgramskihShem="seznamProgramskihShem"
                             :seznamDodatnihPaketov="seznamDodatnihPaketov"
                             :prikaziSamoStoritve="prikaziSamoStoritve"
                             v-on:narociTvSheme="NarociNovPaket"
                             v-on:reloadPodatkov="KlicGlobalnihMetod"
                             v-on:narociNovPaketTvStoritve="NarociNovPaket"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="TV paketi" name="t3" ref="t3"
                             :key="izbranPrikljucek + '-t3-'"
                             v-if="prikaziIzbireTvStoritev === true &&
                             seznamTvPaketov.length > 0">
                  <div>
                    <TVpaketi :izbranPrikljucek="izbranPrikljucek"
                              :seznamTvPaketov="seznamTvPaketov"
                              v-on:orderConfirmed="KlicGlobalnihMetod"
                              v-on:narociTvPaketi="NarociNovPaket"
                    />
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Videoteke" name="t4" ref="t4"
                             :key="izbranPrikljucek + '-t4-'"
                             v-if="prikaziIzbireTvStoritev === true &&
                             seznamVideoteke.length > 0">
                  <div>
                    <TVvideoteke :izbranPrikljucek="izbranPrikljucek"
                                 :seznamVideoteke="seznamVideoteke"
                                 :prikaziHBOGoLink="prikaziHBOGoLink"
                                 v-on:orderConfirmed="KlicGlobalnihMetod"
                                 v-on:narociTvVideoteke="NarociNovPaket"
                    />
                  </div>
                </el-tab-pane>
                <el-tab-pane label="HD programi" name="t5" ref="t5"
                             :key="izbranPrikljucek + '-t5-'"
                             v-if="prikaziIzbireTvStoritev === true &&
                             seznamHDprogramov.length > 0">
                  <div>
                    <TVhdProgrami :izbranPrikljucek="izbranPrikljucek"
                                  :seznamHDprogramov="seznamHDprogramov"
                                  v-on:orderConfirmed="KlicGlobalnihMetod"/>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div v-if="seznamVsehPrikljuckov.length === 0 && !pridobivanjePodatkov">
              <div class="obvestilo-prazen-seznam">
                <p>
                  Na izbrani naročnini ni možno naročati TV storitev.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {VsebinaZaOdrasleGesloEnum} from '../../../../assets/js/Enum/VsebinaZaOdrasleGesloEnum.js'
  import {StoritevVrstaEnum} from '../../../../assets/js/Enum/StoritevVrstaEnum.js'
  import {PridobivanjeProgramov} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarociTelevizija.js'
  import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
  import TVpaketi from './NarociTelevizija/TVpaketi.vue'
  import TVvmesnik from './NarociTelevizija/TVvmesnik.vue'
  import TVvideoteke from './NarociTelevizija/TVvideoteke.vue'
  import TVsheme from './NarociTelevizija/TVsheme.vue'
  import TVhdProgrami from './NarociTelevizija/TVhdProgrami.vue'
  import {Select, Option, Tabs, TabPane, MessageBox, Dialog} from 'element-ui'
  import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
  import ClientAgent from '../../../../assets/js/clientAgent.js'
  import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
  import {SeznamVrednosti} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SeznamVrednosti'
  import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
  import {SteviloDniMedDatumi} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SteviloDniMedDatumi'
  import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
  import {SirinaOkna} from '../../../../assets/js/globalne_funkcije/SirinaOkna'
  import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
  import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'


  export default {
    name: 'NarociTelevizija',
    mixins: [
      SirinaOkna,
      PridobivanjeProgramov,
      PridobivanjeVklopljenoNaroceno,
      StoritevVrstaEnum,
      GetPodatkiIzbirnika,
      StringConverter,
      SeznamVrednosti,
      SteviloDniMedDatumi
    ],
    components: {
      IzbirnikPrikljuckaSelect,
      IzbirnikStranke,
      SteviloDniMedDatumi,
      PridobivanjeProgramov,
      PridobivanjeVklopljenoNaroceno,
      'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
      'TVhdProgrami': TVhdProgrami,
      'TVsheme': TVsheme,
      'TVpaketi': TVpaketi,
      'TVvmesnik': TVvmesnik,
      'TVvideoteke': TVvideoteke,
      [Select.name]: Select,
      [Option.name]: Option,
      [TabPane.name]: TabPane,
      [Tabs.name]: Tabs,
      [Dialog.name]: Dialog
    },
    data () {
      return {
        izbranaStranka: '',
        seznamPrikljuckov: [],
        izbranPrikljucek: null,
        activetab: 't1',
        seznamZaporednihKlicev: [],
        seznamPridobljenihPodatkov: [],
        prikaziIzbireTvStoritev: false,
        seznamHDprogramov: [],
        seznamVideoteke: [],
        seznamDodatnihPaketov: [],
        seznamProgramskihShem: [],
        seznamTvPaketov: [],
        prikaziHBOGoLink: false,
        seznamTvVmesnikov: [],
        seznamNarocenihTvVmesnikov: [],
        seznamVkloplenihTvVmesnikov: [],
        cenikTvVmesnikov: [],
        stPosodobitveKolicineTvVmesnikov: 0,
        gesloVsebinaZaOdrasle: '',
        dodatnaPotrditev: false,
        uspesnoNarociloHBO: false,
        isPrepaid: false,
        seznamVsehPrikljuckov: [],
        selectorPermissions: ['STRANKE_S_PRIKLJUCKI'],
        formaOrientacija: 'left',
        mejnaSirina: 1400,
        pridobivanjePodatkov: true,
        odstranimoSteviloT2TvAppIzSeznama: 5996,
        seznamPrikljuckovGrupirano: [],
        nameTabShemeInStoritve: 'Sheme in storitve',
        prikaziSamoStoritve: false,
        coaxPrikljucek: false
      }
    },
    watch: {
      izbranPrikljucek () {
        if (this.izbranPrikljucek !== null) {
          this.KlicGlobalnihMetod()
        }
      },
      seznamPrikljuckovGrupirano (val) {
        if (val) {
          for (let i = 0; i < val.length; i++) {
            if (typeof val[i] !== 'undefined') {
              for (let j = 0; j < val[i].prikljucki.length; j++) {
                if (val[i].prikljucki[j].id_prikljucek === this.izbranPrikljucek) {
                  this.nameTabShemeInStoritve = ''
                  if (val[i].prikljucki[j].tip_prikljucka === 'FIX') {
                    this.nameTabShemeInStoritve = 'Sheme in storitve'
                    this.prikaziSamoStoritve = false
                  } else {
                    this.nameTabShemeInStoritve = 'TV Storitve'
                    this.prikaziSamoStoritve = true
                  }
                }
              }
            }
          }
        }
      }
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.gesloVsebinaZaOdrasle = VsebinaZaOdrasleGesloEnum.GESLO_PROGRAMI_ZA_ODRASLE
      this.$nextTick(function () {
        window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
        window.dispatchEvent(new Event('resize'))
      })
    },
    methods: {
      GetStranka (podatkiStranke) {
        if (podatkiStranke !== null) {
          this.izbranaStranka = podatkiStranke
          this.GetPrikljuckiDovoljenja(podatkiStranke)
        }
      },
      GetPrikljuckiDovoljenja () {
        if (this.izbranaStranka !== '') {
          let param = ['permissions[]=PRIKLJUCKI']
          this.clientAgent.postWsRequest(
            this,
            'permissions/all',
            param,
            null,
            'SetPrikljuckiDovoljenja',
            'ErrPrikljuckiDovoljenja')
        }
      },
      SetPrikljuckiDovoljenja (podatki) {
        this.seznamPrikljuckovGrupirano = []
        this.seznamVsehPrikljuckov = []
        this.izbranPrikljucek = ''
        this.skupniSeznamPrikljuckov = []
        UrejenSeznamPrikljuckov.methods.UrediSeznam(
          this,
          this.izbranaStranka,
          podatki.results.PRIKLJUCKI.additionalData.filter(x => x.tip_prikljucka !== 'UMTS')
        )
      },
      GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
        this.seznamVsehPrikljuckov = list
        this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
        this.coaxPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.medij === '14' : list[0].medij === '14'
        this.seznamPrikljuckovGrupirano = groupedList
        this.$emit('seznamPrikljuckov', this.seznamVsehPrikljuckov)
        this.pridobivanjePodatkov = false
      },
      ErrPrikljuckiDovoljenja (podatki) {
        this.ShowWarningMessage(podatki)
      },
      KlicGlobalnihMetod () {
        this.seznamDodatnihPaketov = []
        this.seznamProgramskihShem = []
        this.seznamHDprogramov = []
        this.seznamVideoteke = []
        this.seznamTvPaketov = []
        this.seznamNarocenihTvVmesnikov = []
        this.seznamVkloplenihTvVmesnikov = []
        this.prikaziIzbireTvStoritev = false
        // gumb Prijava v Max se ob menjavi priključka ponovno določi iz odgovora (#242428)
        this.prikaziHBOGoLink = false
        let param = {}
        param.vmesnik = this
        param.prenesenIzbranId = this.izbranPrikljucek
        let seznamIskanihStoritev = [StoritevVrstaEnum.TV_PAKETI, StoritevVrstaEnum.TELEVIZIJA]
        param.idVrsta = [].concat(seznamIskanihStoritev, this.GetVrsteStoritveInternet())
        param.idStatusNaroceno = 0
        param.idStatusVklopljeno = 1
        this.seznamZaporednihKlicev = []
        this.seznamZaporednihKlicev.push('GetTvProgrami')
        if (!this.isPrepaid) {
          this.seznamZaporednihKlicev.push('GetVklopljeneStoritve')
          this.seznamZaporednihKlicev.push('GetNaroceneStoritve')
        }
        this.KliciMetodeSSeznama(param)
      },
      KliciMetodeSSeznama (param) {
        if (this.seznamZaporednihKlicev.length > 0) {
          let imeFunkcije = this.seznamZaporednihKlicev[0]
          this[imeFunkcije](param)
          this.seznamZaporednihKlicev.shift()
        }
      },
      HandleTabClick (tab) {
        this.activetab = tab.name
      },
      PrikaziHBOGoLink () {
        this.prikaziHBOGoLink = true
      },
      SetSeznamPodatkovTelevizija (prenosniParametri, seznamProgramov) {
        this.seznamPridobljenihPodatkov = []
        this.seznamVideoteke = []
        this.seznamHDprogramov = []
        this.seznamDodatnihPaketov = []
        this.seznamPridobljenihPodatkov = seznamProgramov
        if (typeof this.seznamPridobljenihPodatkov !== 'undefined') {
          let iTvPaketi = 0
          for (let i = 0; i < this.seznamPridobljenihPodatkov.length; i++) {
            this.seznamPridobljenihPodatkov[i].loading = false
            if ('cena' in this.seznamPridobljenihPodatkov[i]) {
              Vue.set(this.seznamPridobljenihPodatkov[i], 'cenaSI',
                this.PikeVVejice(this.seznamPridobljenihPodatkov[i].cena))
            }
            if (typeof this.seznamPridobljenihPodatkov[i] !== 'undefined' &&
              this.seznamPridobljenihPodatkov[i].prikazanoHorizont === 1) {
              this.prikaziIzbireTvStoritev = true
            }
            if (this.seznamPridobljenihPodatkov[i].naziv_skupine === 'Posamezni HD programi') {
              this.seznamHDprogramov.push(this.seznamPridobljenihPodatkov[i])
            } else if (this.seznamPridobljenihPodatkov[i].naziv_skupine === 'Videoteke') {
              if (!([3445].includes(this.seznamPridobljenihPodatkov[i].idStoritevVrstaIzbira) && this.izbranPrikljucek === '24289')) {
                this.seznamVideoteke.push(this.seznamPridobljenihPodatkov[i])
              }
            } else if (this.seznamPridobljenihPodatkov[i].naziv_skupine === 'Dodatni paketi') {
              this.seznamDodatnihPaketov.push(this.seznamPridobljenihPodatkov[i])
            } else if (this.seznamPridobljenihPodatkov[i].naziv_skupine === 'Tv paketi') {
              if (!([6279, 6025, 70, 3443, 3445].includes(this.seznamPridobljenihPodatkov[i].idStoritevVrstaIzbira) && this.izbranPrikljucek === '24289')) {
                Vue.set(this.seznamTvPaketov, iTvPaketi++, this.seznamPridobljenihPodatkov[i])
              }
            }
            Vue.set(this.seznamPridobljenihPodatkov[i], 'vklopljeno', 0)
            Vue.set(this.seznamPridobljenihPodatkov[i], 'naroceno', 0)
          }
        }
      },
      SetSeznamPodatkovProgramskeSheme (prenParametri, seznamShem) {
        for (let i = 0; i < seznamShem.length; i++) {
          seznamShem[i].loading = false
          Vue.set(this.seznamProgramskihShem, i, JSON.parse(JSON.stringify(seznamShem[i])))
          Vue.set(this.seznamProgramskihShem[i], 'cenaSI', this.PikeVVejice(seznamShem[i].cena))
          Vue.set(this.seznamProgramskihShem[i], 'vklopljeno', 0)
          Vue.set(this.seznamProgramskihShem[i], 'naroceno', 0)
        }
      },
      SetCenikTvVmesnikov (podatki, cenikTvVmesnikov) {
        this.cenikTvVmesnikov = cenikTvVmesnikov
      },
      SetSeznamTvVmesnikov (podatki, seznamTvVmesnikov) {
        this.seznamTvVmesnikov = []
        for (let i = 0; i < seznamTvVmesnikov.length; i++) {
          if (seznamTvVmesnikov[i].id !== this.odstranimoSteviloT2TvAppIzSeznama) {
            this.seznamTvVmesnikov.push(seznamTvVmesnikov[i])
          }
        }
      },
      SetSeznamNarocenihStoritev (prenosniParametri, seznamNarocenih) {
        this.seznamNarocenihTvVmesnikov = []
        this.seznamNarocenih = seznamNarocenih
        if (this.seznamNarocenih.length !== 0) {
          for (let i = 0; i < this.seznamNarocenih.length; i++) {
            if (this.seznamNarocenih[i].idVrsta === parseInt(StoritevVrstaEnum.TELEVIZIJA)) {
              this.seznamNarocenihTvVmesnikov.push(this.seznamNarocenih[i])
            }
            if (typeof this.seznamProgramskihShem !== 'undefined') {
              for (let j = 0; j < this.seznamProgramskihShem.length; j++) {
                if (this.seznamProgramskihShem[j].id === this.seznamNarocenih[i].idStoritev) {
                  Vue.set(this.seznamProgramskihShem[j], 'naroceno', 1)
                }
              }
            }
            if (typeof this.seznamPridobljenihPodatkov !== 'undefined') {
              for (let j = 0; j < this.seznamPridobljenihPodatkov.length; j++) {
                if (this.seznamPridobljenihPodatkov[j].id === seznamNarocenih[i].idStoritev) {
                  Vue.set(this.seznamPridobljenihPodatkov[j], 'vklopljeno', 1)
                }
              }
            }
          }
        }
        this.stPosodobitveKolicineTvVmesnikov++
      },
      SetSeznamVkloplenihStoritev (prenosniParametri, seznamVklopljenih) {
        if (seznamVklopljenih !== 0) {
          for (let i = 0; i < seznamVklopljenih.length; i++) {
            if (seznamVklopljenih[i].idVrsta === parseInt(StoritevVrstaEnum.TELEVIZIJA)) {
              this.seznamVkloplenihTvVmesnikov.push(seznamVklopljenih[i])
            }
            if (typeof this.seznamProgramskihShem !== 'undefined') {
              for (let j = 0; j < this.seznamProgramskihShem.length; j++) {
                if (typeof this.seznamProgramskihShem !== 'undefined') {
                  if (this.seznamProgramskihShem[j].id === seznamVklopljenih[i].idStoritev) {
                    Vue.set(this.seznamProgramskihShem[j], 'vklopljeno', 1)
                  }
                }
              }
            }
            if (typeof this.seznamPridobljenihPodatkov !== 'undefined') {
              for (let j = 0; j < this.seznamPridobljenihPodatkov.length; j++) {
                if (this.seznamPridobljenihPodatkov[j].id === seznamVklopljenih[i].idStoritev) {
                  Vue.set(this.seznamPridobljenihPodatkov[j], 'vklopljeno', 1)
                }
              }
            }
          }
        }
        this.stPosodobitveKolicineTvVmesnikov++
      },
      NarociNovPaket (prenosniParam, status, naziv, zaOddrasle, dodatnaPotrditev) {
        if (this.izbranPrikljucek !== '') {
          if (status === 1 && !dodatnaPotrditev) {
            MessageBox.confirm('Ste prepričani, da želite vklopiti ' + naziv + '?',
              {
                confirmButtonText: 'Da',
                cancelButtonText: 'Prekliči',
                confirmButtonClass: 'gumb-potrdi',
                cancelButtonClass: 'gumb-preklici',
                customClass: 'opozorilo-dialog'
              }).then(() => {
              this.SproziNarocilo(prenosniParam, status, zaOddrasle)
            }).catch((err) => {
              err = null
            })
          } else if (status === 0 && !dodatnaPotrditev) {
            MessageBox.confirm('Ste prepričani, da želite odjaviti ' + naziv + '?', {
              confirmButtonText: 'Da',
              cancelButtonText: 'Prekliči',
              confirmButtonClass: 'gumb-potrdi',
              cancelButtonClass: 'gumb-preklici',
              customClass: 'opozorilo-dialog'
            }).then(() => {
              this.SproziNarocilo(prenosniParam, status, zaOddrasle)
            }).catch((err) => {
              err = null
            })
          }
          if (dodatnaPotrditev && this.izbranPrikljucek !== '') {
            this.SproziNarocilo(prenosniParam, status, zaOddrasle)
            this.dodatnaPotrditev = dodatnaPotrditev
          }
        }
      },
      SproziNarocilo (prenosniParam, status, zaOddrasle) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('seznamStoritev[' + prenosniParam + ']=' + status)
        let prenParam2 = []
        prenParam2['status'] = status
        prenParam2['zaOddrasle'] = zaOddrasle
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/narociStoritve',
          param,
          prenParam2,
          'SetNarociNovPaket',
          'ErrNarociNovPaket')
      },
      SetNarociNovPaket (podatki, prenParam) {
        if (prenParam['status'] === 0) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Uspešno odjavljeno.'
          this.ShowSuccessMessage(paramObvestilo)
        } else if (prenParam['status'] === 1) {
          if (prenParam['zaOddrasle'] === true) {
            MessageBox.alert('Privzeto geslo za ogled zaščitenih TV programov je ' +
            this.gesloVsebinaZaOdrasle +
            '. Prijeten ogled želimo.', 'Naročilo uspešno izvedeno',
            {
              showCancelButton: false,
              showConfirmButton: false,
              closeOnClickModal: true,
              closeOnPressEscape: true,
              customClass: 'opozorilo-dialog'
            }).catch((err) => {
              err = null
            })
          } else {
            if (!this.dodatnaPotrditev) {
              let paramObvestilo = {}
              paramObvestilo.message = 'Hvala za naročilo. Prijeten ogled želimo.'
              this.ShowSuccessMessage(paramObvestilo)
            } else {
              this.uspesnoNarociloHBO = true
            }
          }
        }
        this.KlicGlobalnihMetod()
      },
      ErrNarociNovPaket (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowErrorMessage(paramObvestilo)
      }
    }
  }
</script>
<style scoped src="../../../../../static/css/Naroci/NarociTelevizija/NarociTelevizija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija.vue